import React from 'react';
import { render } from 'react-dom';

const ConfirmAlertOpposite = (
  title,
  label,
  onYes,
  onNo,
  options = { yesLabel: 'Yes', noLabel: 'No' },
  withRemarks
) => {
  const rootElement = document.getElementById('my-confirm-modal');

  const handleYes = () => {
    if (onYes) {
      if (document.getElementById('remarks')) {
        const remarks = document.getElementById('remarks').value;
        onYes(remarks);
      } else {
        onYes();
      }
    }
    render(<div id="my-confirm-modal" />, rootElement);
  };

  const handleNo = () => {
    if (onNo) {
      onNo();
    }
    render(<div id="my-confirm-modal" />, rootElement);
  };

  render(
    <div>
      <form onSubmit={handleYes}>
        <div style={{ position: 'absolute' }}>
          <div
            className="modal show"
            style={{
              display: 'block',
              zIndex: 1051,
              backgroundColor: 'rgba(0, 0, 0, .6)',
              pointerEvents: 'none',
            }}
          >
            <div className="modal-dialog" style={{ pointerEvents: 'initial' }}>
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title">{title}</h4>
                </div>
                <div className="modal-body">
                  <label>{label}</label>
                  {withRemarks && (
                    <div className="form-group">
                      <label>Remarks: </label>
                      <textarea
                        id="remarks"
                        className="form-control"
                        rows={15}
                        required
                      />
                    </div>
                  )}
                </div>
                <div className="modal-footer d-flex justify-content-center">
                  <button
                    type="button"
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary"
                    onClick={handleNo}
                  >
                    {options.noLabel}
                  </button>
                  <button
                    type="submit"
                    className="btn btn-danger text-white"
                  >
                    {options.yesLabel}
                  </button>{' '}
                </div>
              </div>
            </div>
          </div>
          {
            // eslint-disable-next-line
            <div
              className="modal-backdrop fade show"
              style={{ zIndex: 1050, pointerEvents: 'initial' }}
              onClick={handleNo}
            />
          }
        </div>
      </form>
    </div>,
    rootElement
  );
};

export default ConfirmAlertOpposite;
